// ABOUTME: Exports user ID to global scope for native bridge integration
// ABOUTME: Uses safe context access to prevent HMR errors

import type { FC } from "react"
import { useContext, useEffect } from "react"
import { MeContext } from "./model/user/provider"

declare global {
  interface Window {
    /** Read by the native shells to learn who is signed in */
    getUserIdFromReact?: () => string
    getUserIdFromTE?: () => string
  }
}

const ExportReactFunctions: FC = () => {
  const context = useContext(MeContext)

  useEffect(() => {
    if (!context) return

    const { me } = context
    // Define global function to return current user ID.
    window.getUserIdFromReact = () => me.id
    window.getUserIdFromTE = () => me.id
  }, [context])

  return null
}

export default ExportReactFunctions
